import Block from './Block'

export default class Addresses extends Block {
  init() {
    const addressBlocks = this.el.querySelectorAll('.b-addresses__address');

    addressBlocks.forEach((addressBlock) => {
      const switchContainer = addressBlock.querySelector('.b-addresses__address__content__contacts__switch');

      if (!switchContainer) return;

      const labels = switchContainer.querySelectorAll('.b-addresses__address__content__contacts__switch__label');
      const checkbox = switchContainer.querySelector('input[type="checkbox"]');
      const contact1Elements = addressBlock.querySelectorAll('[data-contact="1"]');
      const contact2Elements = addressBlock.querySelectorAll('[data-contact="2"]');

      if (labels.length !== 2) return;

      const toggleContact = (isSecondContact) => {
        switchContainer.classList.toggle('active', isSecondContact);
        labels[0].classList.toggle('active', !isSecondContact);
        labels[1].classList.toggle('active', isSecondContact);

        if (checkbox) {
          checkbox.checked = isSecondContact;
        }

        contact1Elements.forEach(el => {
          el.style.display = isSecondContact ? 'none' : 'flex';
        });

        contact2Elements.forEach(el => {
          el.style.display = isSecondContact ? 'flex' : 'none';
        });
      };

      labels[0].addEventListener('click', () => toggleContact(false));
      labels[1].addEventListener('click', () => toggleContact(true));

      if (checkbox) {
        checkbox.addEventListener('change', () => toggleContact(checkbox.checked));
      }

      // Initial state
      if (checkbox) {
        toggleContact(checkbox.checked);
      } else {
        toggleContact(false);
      }
    });
  }
}
